import { Routes } from '@/components/Routes'
import { Layout } from '@/components/layout'
import { Toaster } from '@/components/ui/sonner'

import './App.css'
import { Providers } from './components/providers/providers'

function App() {
    return (
        <Providers>
            <Layout>
                <Routes />
                <Toaster />
            </Layout>
        </Providers>
    )
}

export default App
